import Highlight, { defaultProps } from 'prism-react-renderer';
import lightTheme from 'prism-react-renderer/themes/github';
import { Header } from '../widgets';
import { LISTURL } from '../config';
import clsx from 'clsx';

const breadcrumbs = [
  { name: 'Hướng dẫn cài đặt', href: LISTURL.documentation, current: true },
];

const themeCode = `
{%if shop.metafields.onistudio['reviewapp.config']%}
<script>window.OniReviewConfig={{shop.metafields.onistudio['reviewapp.config']}}</script>
<script defer src="https://assets.onistudio.net/static/onireviews.js"></script>
{%endif%}
`;
const loopCode = `
<div class="onireviewapp-loop">{{product.metafields.onistudio['reviewapp.loop']}}</div>
`;
const detailCode = `
<div class="onireviewapp-container">
  {{product.metafields.onistudio['reviewapp.detail']}}
  <h3 class="onirvapp-detail-title">Đánh giá, nhận xét khách hàng</h3>
  <div id="onireviewapp" data-customer-email="{{customer.email}}" data-customer-name="{{customer.name}}" data-pid="{{product.id}}"></div>
</div>
`;

const loopFuncCode = `
window.OniReview.loopRender('xs');
`;

const detailFuncCode = `
window.OniReview.detailRender();
`;

const Documentation = (): JSX.Element => {
  return (
    <div className="flex flex-col">
      <Header
        title="Hướng dẫn cài đặt"
        breadcrumbs={breadcrumbs}
        action={null}
      />
      <div className="p-3 mt-3">
        <div className="bg-white p-8 rounded-md space-y-10 text-sm">
          <div className="space-y-4">
            <strong>Bước 1:</strong>
            <p>
              Chèn đoạn mã sau vào cuối file{' '}
              <strong>layouts/theme.liquid</strong> trong giao hiện hiện tại.
              Trước khi đóng thẻ &lt;/ body&gt;
            </p>

            <Highlight
              {...defaultProps}
              theme={lightTheme}
              code={themeCode}
              language="jsx"
            >
              {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre
                  className={clsx(className, 'px-4 rounded-md')}
                  style={style}
                >
                  {tokens.map((line, i) => (
                    <div {...getLineProps({ line, key: i })}>
                      {line.map((token, key) => (
                        <span {...getTokenProps({ token, key })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
            <div className="rounded-md overflow-hidden">
              <img
                className="block w-full h-auto"
                src="https://file.hstatic.net/200000639377/file/screenshot_at_dec_26_16-33-51_cb_3613abca0a7f440e88543e7329d19f0c.jpeg"
                alt=""
              />
            </div>
          </div>
          <div className="space-y-4">
            <strong>Bước 2:</strong>
            <p>
              Chèn đoạn mã sau vào phần muốn hiển thị đánh giá ở các loop sản
              phẩm. Thường nằm trong file{' '}
              <strong>snippets/product-loop.liquid</strong>
            </p>
            <Highlight
              {...defaultProps}
              theme={lightTheme}
              code={loopCode}
              language="jsx"
            >
              {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre
                  className={clsx(className, 'px-4 rounded-md')}
                  style={style}
                >
                  {tokens.map((line, i) => (
                    <div {...getLineProps({ line, key: i })}>
                      {line.map((token, key) => (
                        <span {...getTokenProps({ token, key })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
            <div className="rounded-md overflow-hidden">
              <img
                className="block w-full h-auto"
                src="https://file.hstatic.net/200000639377/file/screenshot_at_dec_26_16-35-01-lo_3e897d6ec3cd4a7f97d5e3a7e85051db.jpeg"
                alt=""
              />
            </div>
          </div>
          <div className="space-y-4">
            <strong>Bước 3:</strong>
            <p>
              Chèn đoạn mã sau vào phần muốn hiển thị đánh giá ở trang chi tiết
              sản phẩm. Nằm trong file <strong>product.liquid</strong>
            </p>
            <Highlight
              {...defaultProps}
              theme={lightTheme}
              code={detailCode}
              language="jsx"
            >
              {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre
                  className={clsx(className, 'px-4 rounded-md')}
                  style={style}
                >
                  {tokens.map((line, i) => (
                    <div {...getLineProps({ line, key: i })}>
                      {line.map((token, key) => (
                        <span {...getTokenProps({ token, key })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
            <div className="rounded-md overflow-hidden">
              <img
                className="block w-full h-auto"
                src="https://file.hstatic.net/200000639377/file/screenshot_at_dec_26_16-35-49_34_853993cc06dc47389f81e081ca654eef.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="p-3 mt-3 space-y-2">
        <p className="font-medium text-sm">API dành cho lập trình viên</p>
        <div className="bg-white p-8 rounded-md space-y-10 text-sm">
          <div className="space-y-2">
            <p>
              Gọi hàm sau khi muốn render loop review, ví dụ sau khi filter
              ajax...
            </p>
            <Highlight
              {...defaultProps}
              theme={lightTheme}
              code={loopFuncCode}
              language="jsx"
            >
              {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre
                  className={clsx(className, 'px-4 rounded-md')}
                  style={style}
                >
                  {tokens.map((line, i) => (
                    <div {...getLineProps({ line, key: i })}>
                      {line.map((token, key) => (
                        <span {...getTokenProps({ token, key })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
          </div>
          <div className="space-y-2">
            <p>
              Gọi hàm sau khi muốn render lại phần review ở trang chi tiết sản
              phẩm
            </p>
            <Highlight
              {...defaultProps}
              theme={lightTheme}
              code={detailFuncCode}
              language="jsx"
            >
              {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre
                  className={clsx(className, 'px-4 rounded-md')}
                  style={style}
                >
                  {tokens.map((line, i) => (
                    <div {...getLineProps({ line, key: i })}>
                      {line.map((token, key) => (
                        <span {...getTokenProps({ token, key })} />
                      ))}
                    </div>
                  ))}
                </pre>
              )}
            </Highlight>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
